import { RootState } from "store";

export const getHasRUWCase = (state: RootState) =>
  state.insuranceApplication.result === "referred_to_underwriter";

export const getHasAcceptedCase = (state: RootState) =>
  state.insuranceApplication.result === "accepted";

export const getLatestInsuranceApplication = (state: RootState) => state.insuranceApplication;
